import { useQuery } from "@tanstack/react-query";

import { DefaultFetchService } from "app/services/fetchService";

const ROUTE = "api/v2/MarketResearch/DemandAnalysis/Trending/Heatmap";

type TrendPeriod = {
    date: string;
    volume: number;
};

type TrendDataPoint = {
    currentPeriod: TrendPeriod;
    previousPeriod: TrendPeriod | null;
};

type TopicIdentifier = {
    seed: string;
    country: number;
    type: "AiTopic";
};

type VolumeChange = {
    change: number;
    growth: "Growing" | "Declining" | "Stagnating";
};

export type HeatmapTopic = {
    name: string;
    identifier: TopicIdentifier;
    trend: TrendDataPoint[];
    volume: number;
    volumeChange: VolumeChange | null;
};

type HeatmapResponse = {
    topic: null;
    topics: HeatmapTopic[];
};

const fetchHeatmapData = async (country: number): Promise<HeatmapResponse> => {
    const fetchService = DefaultFetchService.getInstance();
    return fetchService.get<HeatmapResponse>(ROUTE, { country });
};

export const useTopicsHeatmapData = (country: number) => {
    return useQuery({
        queryKey: [ROUTE, country],
        queryFn: () => fetchHeatmapData(country),
    });
};
